// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M3.25 8.25 6.35 11.2 12.7 4.65%27 fill=%27none%27 stroke=%27%2339A84B%27 stroke-width=%272.35%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/images/video-button-white-play.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.ProfessionalCard_grid-card__OBn2R {
  --pc-surface: #F7F5F1;
  --pc-text: #13231D;
  --pc-muted: #5D7067;
  --pc-primary: #82B194;
  --dimension-color: #304E8F;
  --pc-specialty-text: color-mix(in srgb, var(--dimension-color) 86%, #24342D 14%);
  --pc-specialty-border: color-mix(in srgb, var(--dimension-color) 36%, white 64%);
  --pc-specialty-bg: color-mix(in srgb, var(--dimension-color) 10%, white 90%);
  width: 100%;
  max-width: 288px;
  height: 100%;
  min-width: 0;
  min-height: 492px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(12, 36, 28, 0.08);
  border-radius: 24px;
  background: var(--pc-surface);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  color: var(--pc-text);
  transition: transform 0.16s ease, box-shadow 0.16s ease;
  cursor: pointer;
}
.ProfessionalCard_grid-card__OBn2R:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(14, 42, 34, 0.08);
}
.ProfessionalCard_grid-card__media__iIITE {
  position: relative;
  display: block;
  flex: 0 0 268px;
  width: 100%;
  height: 268px;
  min-height: 268px;
  max-height: 268px;
  overflow: hidden;
  background: #ECEAE5 center 24%/cover no-repeat;
  text-decoration: none;
}
.ProfessionalCard_grid-card__media__iIITE::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.13) 0%, rgba(0, 0, 0, 0) 38%);
  pointer-events: none;
}
.ProfessionalCard_grid-card__media__iIITE img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 24%;
}
.ProfessionalCard_grid-card__body__ngecH {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 16px 16px 17px;
}
.ProfessionalCard_grid-card__copy__ibxdu {
  width: 100%;
  min-height: 0;
  display: block;
  flex-shrink: 0;
}
.ProfessionalCard_grid-card__name__iu4Y- {
  margin: 0;
  display: block;
  color: var(--pc-text);
  font-size: 22.5px;
  line-height: 1.04;
  font-weight: 800;
  letter-spacing: -0.028em;
}
.ProfessionalCard_grid-card__role__kCu7z {
  margin: 6px 0 0;
  min-height: 2.56em;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #3F574C;
  font-size: 13px;
  line-height: 1.28;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}
.ProfessionalCard_grid-card__specialties__KFy9r {
  margin-top: 10px;
  min-height: 27px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.ProfessionalCard_grid-card__specialties__KFy9r:empty {
  visibility: hidden;
}
.ProfessionalCard_grid-card__specialties-icon__C5ETD {
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  flex: 0 0 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #8B9A92;
  align-self: center;
}
.ProfessionalCard_grid-card__specialties-icon__C5ETD svg {
  width: 16px;
  height: 16px;
  display: block;
}
.ProfessionalCard_grid-card__specialties-list__WN8QT {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
}
.ProfessionalCard_grid-card__specialty-chip__ddlS3, .ProfessionalCard_grid-card__specialty-more__PGmF5 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 27px;
  height: 27px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 11.5px;
  line-height: 1;
  font-weight: 700;
  white-space: nowrap;
}
.ProfessionalCard_grid-card__specialty-chip__ddlS3 {
  min-width: 0;
  max-width: 178px;
  overflow: hidden;
  border: 1px solid var(--pc-specialty-border);
  background: var(--pc-specialty-bg);
  color: var(--pc-specialty-text);
}
.ProfessionalCard_grid-card__specialty-text__IeBDB {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  font-size: 11.5px;
  line-height: 1.2;
  font-weight: 700;
}
.ProfessionalCard_grid-card__specialty-more__PGmF5 {
  flex: 0 0 auto;
  padding-inline: 10px;
  border: 1px solid color-mix(in srgb, var(--dimension-color) 24%, white 76%);
  background: color-mix(in srgb, var(--dimension-color) 8%, white 92%);
  color: color-mix(in srgb, var(--dimension-color) 82%, #3F574C 18%);
}
.ProfessionalCard_grid-card__msp-row__del8A {
  min-height: 22px;
  margin-top: 10px;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
}
.ProfessionalCard_grid-card__msp-row__del8A:empty {
  visibility: hidden;
}
.ProfessionalCard_grid-card__msp__ob5nW {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--pc-muted);
  font-size: 10.5px;
  line-height: 1.15;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: none;
}
.ProfessionalCard_grid-card__msp__ob5nW::before {
  content: "";
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  background: no-repeat center/16px 16px url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.ProfessionalCard_grid-card__cta__JWIEK {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 0;
  min-height: 40px;
  margin-top: auto;
  padding: 0 16px;
  border: 1px solid rgba(130, 177, 148, 0.58);
  border-radius: 15px;
  background: transparent;
  color: #32453B;
  font: inherit;
  font-size: 12px;
  line-height: 1.2;
  font-weight: 800;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease, transform 0.12s ease;
}
.ProfessionalCard_grid-card__cta__JWIEK:hover {
  border-color: rgba(130, 177, 148, 0.88);
  background: rgba(130, 177, 148, 0.12);
  color: #32453B;
}
.ProfessionalCard_grid-card__cta__JWIEK:focus-visible {
  outline: 3px solid rgba(130, 177, 148, 0.24);
  outline-offset: 2px;
  border-color: var(--pc-primary);
}
.ProfessionalCard_grid-card__cta__JWIEK:active {
  border-color: var(--pc-primary);
  background: rgba(130, 177, 148, 0.18);
  transform: translateY(1px);
}
.ProfessionalCard_grid-card__video-trigger__voJGX {
  position: absolute;
  left: 16px;
  bottom: 16px;
  z-index: 3;
  width: 64px;
  height: 46px;
  padding: 0;
  border: 0;
  border-radius: 14px;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/contain no-repeat;
  filter: drop-shadow(0 8px 12px rgba(16, 25, 21, 0.16));
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  transition: opacity 0.2s ease;
}
.ProfessionalCard_grid-card__video-trigger__voJGX:hover {
  opacity: 0.9;
}
.ProfessionalCard_grid-card__video-trigger__voJGX:focus-visible {
  outline: 3px solid rgba(255, 255, 255, 0.38);
  outline-offset: 3px;
}
.ProfessionalCard_grid-card__video-container__Uap7R {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 3;
}
.ProfessionalCard_grid-card__video-container__Uap7R iframe,
.ProfessionalCard_grid-card__video-container__Uap7R video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
@media (max-width: 760px) {
  .ProfessionalCard_grid-card__OBn2R {
    width: min(100%, 288px);
    margin-inline: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/pages/ProfessionalsList/ProfessionalCard/ProfessionalCard.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACE,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,0BAAA;EACA,gFAAA;EACA,gFAAA;EACA,4EAAA;EAEA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,wCAAA;EACA,mBAAA;EACA,6BAAA;EACA,2CAAA;EACA,qBAAA;EACA,uDAAA;EACA,eAAA;AAgBF;AAdE;EACE,2BAAA;EACA,8CAAA;AAgBJ;AAbE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,8CAAA;EACA,qBAAA;AAeJ;AAbI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,iFAAA;EACA,oBAAA;AAeN;AAZI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;AAcN;AAVE;EACE,cAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,uBAAA;AAYJ;AATE;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;AAWJ;AARE;EACE,SAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;AAUJ;AAPE;EACE,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AASJ;AANE;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAQJ;AANI;EACE,kBAAA;AAQN;AAJE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;AAMJ;AAJI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAMN;AAFE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAIJ;AADE;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAEJ;AACE;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,4CAAA;EACA,kCAAA;EACA,+BAAA;AACJ;AAEE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,cAAA;EACA,oBAAA;EACA,2EAAA;EACA,oEAAA;EACA,kEAAA;AADJ;AAIE;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAFJ;AAII;EACE,kBAAA;AAFN;AAME;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAJJ;AAMI;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,8EAAA;AAJN;AAQE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,2CAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,kGAAA;AANJ;AAQI;EACE,uCAAA;EACA,qCAAA;EACA,cAAA;AANN;AASI;EACE,4CAAA;EACA,mBAAA;EACA,+BAAA;AAPN;AAUI;EACE,+BAAA;EACA,qCAAA;EACA,0BAAA;AARN;AAYE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,wFAAA;EACA,sDAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,6BAAA;AAVJ;AAYI;EACE,YAAA;AAVN;AAaI;EACE,4CAAA;EACA,mBAAA;AAXN;AAeE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AAbJ;AAeI;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;AAbN;AAiBE;EA1SF;IA2SI,uBAAA;IACA,mBAAA;EAdF;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../assets/styles/variables';\n\n.grid-card {\n  --pc-surface: #F7F5F1;\n  --pc-text: #13231D;\n  --pc-muted: #5D7067;\n  --pc-primary: #82B194;\n  --dimension-color: #304E8F; // Overridden inline\n  --pc-specialty-text: color-mix(in srgb, var(--dimension-color) 86%, #24342D 14%);\n  --pc-specialty-border: color-mix(in srgb, var(--dimension-color) 36%, white 64%);\n  --pc-specialty-bg: color-mix(in srgb, var(--dimension-color) 10%, white 90%);\n\n  width: 100%;\n  max-width: 288px;\n  height: 100%;\n  min-width: 0;\n  min-height: 492px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid rgba(12, 36, 28, .08);\n  border-radius: 24px;\n  background: var(--pc-surface);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, .03);\n  color: var(--pc-text);\n  transition: transform .16s ease, box-shadow .16s ease;\n  cursor: pointer;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 12px 28px rgba(14, 42, 34, .08);\n  }\n\n  &__media {\n    position: relative;\n    display: block;\n    flex: 0 0 268px;\n    width: 100%;\n    height: 268px;\n    min-height: 268px;\n    max-height: 268px;\n    overflow: hidden;\n    background: #ECEAE5 center 24%/cover no-repeat;\n    text-decoration: none;\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      inset: 0;\n      background: linear-gradient(to top, rgba(0, 0, 0, .13) 0%, rgba(0, 0, 0, 0) 38%);\n      pointer-events: none;\n    }\n\n    img {\n      display: block;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center 24%;\n    }\n  }\n\n  &__body {\n    flex: 1 1 auto;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    padding: 16px 16px 17px;\n  }\n\n  &__copy {\n    width: 100%;\n    min-height: 0;\n    display: block;\n    flex-shrink: 0;\n  }\n\n  &__name {\n    margin: 0;\n    display: block;\n    color: var(--pc-text);\n    font-size: 22.5px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -.028em;\n  }\n\n  &__role {\n    margin: 6px 0 0;\n    min-height: calc(1.28em * 2);\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: #3F574C;\n    font-size: 13px;\n    line-height: 1.28;\n    font-weight: 700;\n    letter-spacing: 0;\n    text-transform: none;\n  }\n\n  &__specialties {\n    margin-top: 10px;\n    min-height: 27px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    &:empty {\n      visibility: hidden;\n    }\n  }\n\n  &__specialties-icon {\n    width: 16px;\n    height: 16px;\n    min-width: 16px;\n    min-height: 16px;\n    flex: 0 0 16px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: #8B9A92;\n    align-self: center;\n\n    svg {\n      width: 16px;\n      height: 16px;\n      display: block;\n    }\n  }\n\n  &__specialties-list {\n    min-width: 0;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    overflow: hidden;\n  }\n\n  &__specialty-chip,\n  &__specialty-more {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 27px;\n    height: 27px;\n    padding: 0 12px;\n    border-radius: 999px;\n    font-size: 11.5px;\n    line-height: 1;\n    font-weight: 700;\n    white-space: nowrap;\n  }\n\n  &__specialty-chip {\n    min-width: 0;\n    max-width: 178px;\n    overflow: hidden;\n    border: 1px solid var(--pc-specialty-border);\n    background: var(--pc-specialty-bg);\n    color: var(--pc-specialty-text);\n  }\n\n  &__specialty-text {\n    display: block;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    text-align: left;\n    font-size: 11.5px;\n    line-height: 1.2;\n    font-weight: 700;\n  }\n\n  &__specialty-more {\n    flex: 0 0 auto;\n    padding-inline: 10px;\n    border: 1px solid color-mix(in srgb, var(--dimension-color) 24%, white 76%);\n    background: color-mix(in srgb, var(--dimension-color) 8%, white 92%);\n    color: color-mix(in srgb, var(--dimension-color) 82%, #3F574C 18%);\n  }\n\n  &__msp-row {\n    min-height: 22px;\n    margin-top: 10px;\n    margin-bottom: 18px;\n    display: flex;\n    align-items: center;\n\n    &:empty {\n      visibility: hidden;\n    }\n  }\n\n  &__msp {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    color: var(--pc-muted);\n    font-size: 10.5px;\n    line-height: 1.15;\n    font-weight: 800;\n    letter-spacing: 0;\n    text-transform: none;\n\n    &::before {\n      content: \"\";\n      width: 16px;\n      height: 16px;\n      flex: 0 0 16px;\n      background: no-repeat center/16px 16px url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M3.25 8.25 6.35 11.2 12.7 4.65' fill='none' stroke='%2339A84B' stroke-width='2.35' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n    }\n  }\n\n  &__cta {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    min-width: 0;\n    min-height: 40px;\n    margin-top: auto;\n    padding: 0 16px;\n    border: 1px solid rgba(130, 177, 148, .58);\n    border-radius: 15px;\n    background: transparent;\n    color: #32453B;\n    font: inherit;\n    font-size: 12px;\n    line-height: 1.2;\n    font-weight: 800;\n    text-decoration: none;\n    cursor: pointer;\n    transition: background .16s ease, border-color .16s ease, color .16s ease, transform .12s ease;\n\n    &:hover {\n      border-color: rgba(130, 177, 148, .88);\n      background: rgba(130, 177, 148, .12);\n      color: #32453B;\n    }\n\n    &:focus-visible {\n      outline: 3px solid rgba(130, 177, 148, .24);\n      outline-offset: 2px;\n      border-color: var(--pc-primary);\n    }\n\n    &:active {\n      border-color: var(--pc-primary);\n      background: rgba(130, 177, 148, .18);\n      transform: translateY(1px);\n    }\n  }\n\n  &__video-trigger {\n    position: absolute;\n    left: 16px;\n    bottom: 16px;\n    z-index: 3;\n    width: 64px;\n    height: 46px;\n    padding: 0;\n    border: 0;\n    border-radius: 14px;\n    background: transparent url('../../../assets/images/video-button-white-play.png') center/contain no-repeat;\n    filter: drop-shadow(0 8px 12px rgba(16, 25, 21, .16));\n    cursor: pointer;\n    appearance: none;\n    -webkit-appearance: none;\n    transition: opacity 0.2s ease;\n\n    &:hover {\n      opacity: .9;\n    }\n\n    &:focus-visible {\n      outline: 3px solid rgba(255, 255, 255, .38);\n      outline-offset: 3px;\n    }\n  }\n\n  &__video-container {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    z-index: 3;\n\n    iframe,\n    video {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n\n  @media(max-width: 760px) {\n    width: min(100%, 288px);\n    margin-inline: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid-card": `ProfessionalCard_grid-card__OBn2R`,
	"grid-card__media": `ProfessionalCard_grid-card__media__iIITE`,
	"grid-card__body": `ProfessionalCard_grid-card__body__ngecH`,
	"grid-card__copy": `ProfessionalCard_grid-card__copy__ibxdu`,
	"grid-card__name": `ProfessionalCard_grid-card__name__iu4Y-`,
	"grid-card__role": `ProfessionalCard_grid-card__role__kCu7z`,
	"grid-card__specialties": `ProfessionalCard_grid-card__specialties__KFy9r`,
	"grid-card__specialties-icon": `ProfessionalCard_grid-card__specialties-icon__C5ETD`,
	"grid-card__specialties-list": `ProfessionalCard_grid-card__specialties-list__WN8QT`,
	"grid-card__specialty-chip": `ProfessionalCard_grid-card__specialty-chip__ddlS3`,
	"grid-card__specialty-more": `ProfessionalCard_grid-card__specialty-more__PGmF5`,
	"grid-card__specialty-text": `ProfessionalCard_grid-card__specialty-text__IeBDB`,
	"grid-card__msp-row": `ProfessionalCard_grid-card__msp-row__del8A`,
	"grid-card__msp": `ProfessionalCard_grid-card__msp__ob5nW`,
	"grid-card__cta": `ProfessionalCard_grid-card__cta__JWIEK`,
	"grid-card__video-trigger": `ProfessionalCard_grid-card__video-trigger__voJGX`,
	"grid-card__video-container": `ProfessionalCard_grid-card__video-container__Uap7R`
};
export default ___CSS_LOADER_EXPORT___;
